module.exports = __webpack_public_path__ + "static/darkTextureBackground-ae8d32a03390a561f822e06e189d2bf6.svg";